import { render, staticRenderFns } from "./OptimizedProposedSelectWrapper.vue?vue&type=template&id=1c23a67a&"
import script from "./OptimizedProposedSelectWrapper.vue?vue&type=script&lang=js&"
export * from "./OptimizedProposedSelectWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports